<template>
  <l-layout :layout="['xs12']">
    <l-cache :get-data="getUser" :id="this.$route.query.id" ref="cache">
      <template slot-scope="{data}">
        <user-details-content
          :data="data"
          :from="from"
          @showExtraInfo="changeShowExtraInfo"
        >
          <template slot="actions">
            <v-btn @click="goExtra(data)" class="mx-0" color="primary" flat >额外配置</v-btn>
            <v-btn @click="goEdit(data)" class="mx-0" color="primary" flat >编辑</v-btn>
            <v-btn :loading="loading" @click="refresh()" class="mx-0" color="primary" flat>刷新</v-btn>
          </template>
        </user-details-content>
      </template>
    </l-cache>
  </l-layout>
</template>

<script>
import UserDetailsContent from './userDetailsContent'
export default {
  name: 'UserDetails',
  components: {UserDetailsContent},
  data: () => ({
    status: 'edit',
    loading: false,
    from: 'user',
    showExtend: false
  }),
  created () {
    this.from = this.$route.query.from
  },
  methods: {
    goEdit (person = {}) {
      // this.$store.commit('closeTab', this.$route.fullPath)
      this.$store.dispatch('L/routerInTab').then(() => {
        this.$router.replace({
          name: 'EditUser',
          params: {loginId: person.loginId},
          query: {id: person.id, showExtend: this.showExtend, from: this.from}
        })
      })
    },
    goExtra(person = {}){
      this.$router.push({
        name:'userExtraConfigBox',
        query:{
          id:this.$route.query.id,
          loginId:person.loginId
        }
      })
    },
    async refresh () {
      if (this.$refs.cache) {
        this.loading = true
        await this.$refs.cache.retry(true)
        this.loading = false
      }
    },
    async getUser (key) {
      let p = await this.$store.dispatch('login/getThemSelfInfo', key)
      return p
    },
    changeShowExtraInfo (data) {
      this.showExtend = data
    }
  }
}
</script>

<style scoped>

</style>
